export default "__VITE_ASSET__04f57e47__"